import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import fi from './locales/fi.json';
import sv from './locales/sv.json';
import no from './locales/no.json';
import da from './locales/da.json';
import de from './locales/de.json';
import fr from './locales/fr.json';
import nl from './locales/nl.json';
import pl from './locales/pl.json';

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            en: { translation: en },
            fi: { translation: fi },
            sv: { translation: sv },
            no: { translation: no },
            da: { translation: da },
            de: { translation: de },
            fr: { translation: fr },
            nl: { translation: nl },
            pl: { translation: pl },
        },
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },
        detection: {
            order: ['localStorage', 'navigator'],
            lookupLocalStorage: 'halton-service-language',
            caches: ['localStorage'],
        },
    });

export default i18n;
